import styled from 'styled-components';

const FilterGroupWrapper = styled.div`
  margin-top: 2rem;
`;

FilterGroupWrapper.displayName = 'FilterGroupWrapper';

export default FilterGroupWrapper;
